import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-2">
          用户口碑
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          来看看读者们是怎么评价八仔漫画网的
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-background-100 rounded-lg p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                    </div>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t.content}
              </p>
              <p className="text-xs text-foreground-400 mt-3">{t.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}